import app from "../config/firebase";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  onSnapshot,
  doc,
  setDoc,
  addDoc,
} from "firebase/firestore";

const db = getFirestore();

export const getPendingData = (currentUser, setData) => {
  return onSnapshot(
    collection(db, "users", currentUser, "records"),
    (querySnapshot) => {
      const records = [];
      querySnapshot.forEach((doc) => {
        if (doc.data().status == "pending") {
          records.push({
            status: doc.data().status,
            timeStamp: doc.data().timeStamp,
            count: doc.data().count,
            ipfsHash: doc.id,
          });
        }
      });
      setData(records);
    }
  );
};
export const getData = (currentUser, setData) => {
  return onSnapshot(
    collection(db, "users", currentUser, "records"),
    (querySnapshot) => {
      const records = [];
      querySnapshot.forEach((doc) => {
        records.push({
          status: doc.data().status,
          timeStamp: doc.data().timeStamp,
          count: doc.data().count,
          ipfsHash: doc.id,
        });
      });
      setData(records);
    }
  );
};

export const updateVerified = (currentUser, hash, txn) => {
  return setDoc(
    doc(db, "users", currentUser, "records", hash),
    { status: "verified", txnHash: txn },
    { merge: true }
  );
};

export const uploadData = (currentUser, hash, data) => {
  return setDoc(doc(db, "users", currentUser, "records", hash), {
    data,
    status: "pending",
    timeStamp: Date.now(),
    count: data.length,
  });
};

export const contactSubmission = (values) => {
  return addDoc(collection(db, "contacts"), {
    ...values,
  });
};

export const newRecord = () => {
  return addDoc(collection(db, "test"), {
    name: "Test Successful",
  });
};
